import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import {
  createPendingEmailCooldownSlice,
  type PendingEmailCooldownSlice,
} from '~/components/v2/store/shared/createPendingEmailCooldownSlice';
import { ZustandStorageKeys } from '~/constants/zustandStorageKeys';

/**
 * Persisted in sessionStorage so a page refresh within the cooldown window
 * can't bypass the gate. Shared across the banner, notice, and form.
 */
export const usePendingEmailCooldownStore = create<PendingEmailCooldownSlice>()(
  persist((set, get, store) => createPendingEmailCooldownSlice(set, get, store), {
    name: ZustandStorageKeys.PendingEmailCooldown,
    storage: createJSONStorage(() => sessionStorage),
  }),
);
